import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { WebCustomer } from "../../../models";
import { CustomerService, SharedService } from "../../../services";
import { Subscription } from "rxjs";
import { filter } from "rxjs/operators";

@Component({
  selector: "app-request-dialog-header",
  templateUrl: "./request-dialog-header.component.html",
  styleUrls: ["./request-dialog-header.component.scss"]
})
export class RequestDialogHeaderComponent implements OnInit, OnDestroy
{

  customerSubscription: Subscription;
  customer: WebCustomer;

  constructor(
    public sharedService: SharedService,
    private customerService: CustomerService,

  ) { }

  ngOnInit(): void
  {
    this.customerSubscription = this.customerService.customer
      .pipe(filter(customer => !!customer))
      .subscribe(customer =>
      {
        this.customer = customer;
      });
  }

  ngOnDestroy(): void
  {
    this.customerSubscription.unsubscribe();
  }
}
